import { render, staticRenderFns } from "./UserPickerExtended.vue?vue&type=template&id=514c1744"
import script from "./UserPickerExtended.js?vue&type=script&lang=js&external"
export * from "./UserPickerExtended.js?vue&type=script&lang=js&external"
import style0 from "./UserPickerExtended.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports